import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Switch, Table, Tag, Tooltip } from "antd";
import Compact from "antd/es/space/Compact";
import { useMemo } from "react";
import EditTechCard from "src/features/Modal/ui/EditTechCard";
import { EditableCell, EditableRow } from "src/shared";
import { setColumnCellProps } from "../lib/setCollumnCellProps";
import { COL_TECHCARDS } from "../model/constants";

export default function TechCards({
  handleRemove,
  handleSave,
  dataSource,
  token,
}) {

const columns = useMemo(
  () =>
    setColumnCellProps(COL_TECHCARDS, {
      name: [
        {
          key: "render",
          action: (text, record) => (
            <div>
              <div style={{ fontWeight: 500 }}>{text}</div>
              {record.code && (
                <div style={{ fontSize: 12, color: '#666' }}>Код: {record.code}</div>
              )}
            </div>
          ),
        },
      ],
      card_type: [
        {
          key: "render",
          action: (type) => {
            const typeConfig = {
              reference: { color: 'blue', text: 'Эталонная' },
              production: { color: 'green', text: 'Производственная' },
              calculation: { color: 'orange', text: 'Расчетная' },
            };
            const config = typeConfig[type] || { color: 'default', text: type };
            return <Tag color={config.color}>{config.text}</Tag>;
          },
        },
      ],
      description: [
        {
          key: "render",
          action: (text) => (
            <Tooltip title={text}>
              <span style={{ 
                display: 'block',
                maxWidth: 200,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {text || '—'}
              </span>
            </Tooltip>
          ),
        },
      ],
      items_count: [
        {
          key: "render",
          action: (_, record) => (
            <Tag>{record.items ? record.items.length : 0} позиций</Tag>
          ),
        },
      ],
      status: [
        {
          key: "render",
          action: (checked, record) => (
            <Switch
              checked={checked}
              onChange={(checked) => {
                record.status = checked;
                handleSave(record);
              }}
            />
          ),
        },
      ],
      action: [
        {
          key: "render",
          action: (_, record) => (
            <Compact style={{ padding: 0 }}>
              <EditTechCard
                record={record}
                handleSave={handleSave}
                token={token}
                buttonProps={{ style: { marginRight: 0 } }}
              />
              <Button 
                icon={<EyeOutlined />} 
                onClick={() => {
                  console.log("View tech card:", record);
                }}
              />
              <Popconfirm
                title="Подтвердите удаление"
                description="Вы уверены, что хотите удалить эту техкарту?"
                onConfirm={() => handleRemove(record.id)}
                okText="Да"
                cancelText="Нет"
              >
                <Button icon={<DeleteOutlined />} danger />
              </Popconfirm>
            </Compact>
          ),
        },
        {
          key: "align",
          action: "center",
        },
        {
          key: "onCell",
          action: () => ({
            style: {
              padding: 0,
            },
          }),
        },
      ],
    }),
  [handleRemove, handleSave, token]
);

  return (
    <Table
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={dataSource}
      components={{
        body: {
          cell: EditableCell,
          row: EditableRow,
        },
      }}
      bordered
      rowClassName={() => "editable-row"}
      style={{ width: "100%" }}
      pagination={{
        pageSize: 20,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => 
          `${range[0]}-${range[1]} из ${total} техкарт`,
      }}
      scroll={{ x: 1000 }}
    />
  );
}
